// Wake hints only. No request inputs, file paths or authority travel here.
// The worker still polls its authenticated queue and authorizes every request.
const listeners = new Set();
let connection = { userId: null, generation: null, connected: false };
const publish = signal => { for (const listener of listeners) { try { listener(signal); } catch { /* one retired consumer must not interrupt socket handlers */ } } };
export const subscribeProjectRequestSignals = listener => { listeners.add(listener); return () => listeners.delete(listener); };
export const projectSignalConnection = () => connection;

export function attachProjectRequestSignals(socket, { userId, generation, isCurrent }) {
  const status = connected => {
    if (!isCurrent()) return;
    connection = { userId: String(userId), generation, connected };
    publish({ ...connection, type: 'connection' });
  };
  socket.on('connect', () => status(true));
  socket.on('disconnect', () => status(false));
  socket.on('connect_error', () => status(false));
  socket.on('project:request-ready', data => {
    if (!isCurrent() || !data || typeof data.deviceId !== 'string' || data.deviceId.length > 100 ||
        typeof data.bindingId !== 'string' || data.bindingId.length > 100) return;
    publish({ type: 'ready', userId: String(userId), generation, deviceId: data.deviceId, bindingId: data.bindingId });
  });
  status(socket.connected === true);
}
